export const AGREEMENT_KINDS = [
    "guidelines",
    "technical",
    "legal",
    "licence",
    "usage",
];
export const AGREEMENT_LABEL = {
    guidelines: "Content guidelines",
    technical: "Technical specification",
    legal: "Legal terms",
    licence: "Licence terms",
    usage: "Usage terms",
};
